import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";

import AuthImage from "@/react-components/AuthImage";
import { isDisconnected, sitecoreApiHost } from "@/util";
import { substringEllipsis, isEmpty } from "@/utils";
import { withTranslation } from "react-i18next";
import { api } from "@/utils/api";

class ArticleTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHotBadgeDate: null,
    };
  }
  componentDidMount() {
    if(this.props.articles){
      this.getShowHotBadgeDate();
    }
  }

  click = () => {
    const {
      history: { push },
      articles,
    } = this.props;
    push(articles.link);
  };

  getShowHotBadgeDate = () => {
    const { t } = this.props;
    api.common
      .getTime()
      .then((response) => {
        const showHotBadgeDate = new Date(response);
        const numberOfDaysOfHotResearch = parseInt(
          t("hot_research_number_of_days"));
        showHotBadgeDate.setDate(showHotBadgeDate.getDate() - numberOfDaysOfHotResearch);
        this.setState({ showHotBadgeDate });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { showHotBadgeDate} = this.state;
    const { articles: article } = this.props;
    const showHotBadge = showHotBadgeDate !== null && new Date(article.publicDate) >= showHotBadgeDate && article.tags.indexOf("z2") !== -1;

    return (
      <div className="flex-row news-primary-item">
        <div
          className="flex-column news-primary-image-wrapper"
          onClick={this.click}
          tabIndex="0"
        >
          <AuthImage
            className="news-primary-img"
            src={
              isDisconnected
                ? `${sitecoreApiHost}${article.cover}`
                : article.cover
            }
            isZoom={false}
            alt=""
          />
          {showHotBadge && <AuthImage src={this.props.t("hot_research_icon")} className="hot-icon" isZoom={false} />}
        </div>
        <div className="flex-column news-primary-item-info">
          <RouterLink className="page-title-text" to={article.link}>
            {article.title}
          </RouterLink>
          {article.tagModel && article.tagModel.length > 0 && (
            <div className="news-primary-item-label-container ellipsis-text">
              <span className="news-primary-item-time">
                {article?.publicDate?.slice(0, 10)?.replace(/-/g, ".")}
              </span>
              {article.tagModel.map(
                (item, index) =>
                  !isEmpty(item.text) && (
                    <span
                      key={index}
                      className="news-primary-item-label single-line-text"
                    >
                      {substringEllipsis(item.text)}
                    </span>
                  )
              )}
            </div>
          )}
          <p className="news-primary-item-desc text-max-5-line">
            {article.summary}
          </p>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslation()(ArticleTop));